import { GameRoom, RoomPlayer } from './types';

export type Seat = { kind: 'empty' | 'bot' | 'player'; player?: RoomPlayer };

// A visual arrangement, not the physical seat order in the game server.
export function seatsForRoom(room: GameRoom): Seat[] {
  const seats: Seat[] = room.players.map((player) => ({ kind: 'player', player }));
  for (let i = 0; i < Math.max(0, room.bot_count) && seats.length < 3; i++) {
    seats.push({ kind: 'bot' });
  }
  while (seats.length < 3) seats.push({ kind: 'empty' });
  return seats.slice(0, 3);
}

export function roomState(room: GameRoom): string {
  if (room.status === 'creating') return 'Preparing';
  if (room.status === 'active' || room.players.some((p) => p.status === 'playing')) return 'Playing';
  if (!room.players.length && !room.bot_count) return 'Empty';
  return room.is_joinable ? 'Waiting' : 'Seating';
}

// Staggered schematic rows use the room width instead of stacking tall lounges.
export function floorColumns(count: number) {
  return count <= 2 ? 2 : count <= 6 ? 3 : 4;
}
export function floorWidth(count: number) {
  return floorColumns(count) * 340 + 100;
}
export function tablePosition(index: number, count = 12) {
  const columns = floorColumns(count);
  const row = Math.floor(index / columns);
  const column = index % columns;
  return { x: 210 + column * 340 + (row % 2) * 20, y: 185 + row * 320 + (column % 2) * 20 };
}
export function floorHeight(count: number) {
  return Math.max(1, Math.ceil(count / floorColumns(count))) * 320 + 90;
}
export function fitFloorScale(width: number, height: number, count: number) {
  return Math.min(1, Math.max(1, width) / floorWidth(count), Math.max(1, height) / floorHeight(count));
}
